<template>
    <div ref="carousel" class="mm-carousel">
        <div class="carousel__wrapper"
            :style="styleCarousel__wrapper">

            <div v-if="isReady"
                class="carousel__inner"
                :style="{
                    width: `${widthCarousel__inner}px`,
                    transform: `translate(${-shiftPx}px, 0px)`
                }">

                <CarouselItem
                    v-for="(item, index) in copiedItemsBefore"
                    :key="`copied-b-${item.id}`"
                    :indexDiff="Math.abs((index - centeredItemIndex))"
                    :isCenterd="centeredItemIndex === index"
                    :styleItem="styleItem"
                    :showCount="showCount"
                    :index="index"
                    :onItemClick="onItemClick"
                    :item="item"
                    :itemInnerStyle="(Math.abs((index - centeredItemIndex)) < 3) && {
                        backgroundImage: `url(${item.imageUrl})`
                    }"
                />

                <CarouselItem
                    v-for="(item, index) in items"
                    :key="item.id"
                    :indexDiff="Math.abs((centeredItemIndex  - (index + copiedItemsBefore.length)))"
                    :isCenterd="centeredItemIndex === (index + copiedItemsBefore.length)"
                    :styleItem="styleItem"
                    :showCount="showCount"
                    :index="index"
                    :onItemClick="onItemClick"
                    :item="item"
                    :itemInnerStyle="(Math.abs((centeredItemIndex  - (index + copiedItemsBefore.length))) < 3) && {
                        backgroundImage: `url(${item.imageUrl})`
                    }"
                />

                <CarouselItem
                    v-for="(item, index) in copiedItemsAfter"
                    :key="`copied-a-${item.id}`"
                    :indexDiff="Math.abs((centeredItemIndex  - (index + copiedItemsBefore.length + items.length)))"
                    :isCenterd="centeredItemIndex === (index + copiedItemsBefore.length + items.length)"
                    :styleItem="styleItem"
                    :showCount="showCount"
                    :index="index"
                    :onItemClick="onItemClick"
                    :item="item"
                    :itemInnerStyle="(Math.abs((centeredItemIndex  - (index + copiedItemsBefore.length + items.length))) < 3) && {
                        backgroundImage: `url(${item.imageUrl})`
                    }"
                />
            </div>
        </div>
        <div class="carousel-button-wrapper carousel-button-wrapper-move-left"></div>
        <div class="carousel-button-wrapper carousel-button-wrapper-move-right"></div>

        <div
            class="carousel-button button-move-left"
            :disabled="runningAnimation"
            @click="move(shift - moveByN)">
            <span class="icon icon-arrow-left"></span>
        </div>
        <div
            class="carousel-button button-move-right"
            :disabled="runningAnimation"
            @click="move(shift + moveByN)">
            <span class="icon icon-arrow-right"></span>
        </div>
    </div>
</template>

<script>

import CarouselItem from './CarouselItem';

export default {
    components: {
        CarouselItem
    },
    props: {
        animationDuration: {
            type: Number,
            default: 0,
        },
        animationFramesCount: {
            type: Number,
            default: 1
        },
        maxShowCount: {
            type: Number,
            default: 5
        },
        minItemWidth: {
            type: Number,
            default: 150
        },
        items: {
            type: Array,
            required: true
        },
        onItemClick: {
            type: Function,
            required: true
        },
        spaceSides: {
            type: Number,
            default: 0
        },
        defaultMoveByN: {
            type: Number
        }
    },
    created: function () {
        window.addEventListener('resize', this.handleResize)
    },
    destroyed: function () {
        window.removeEventListener('resize', this.handleResize)
    },
    mounted() {
        const width = this.$refs.carousel.clientWidth - 2 * this.spaceSides;
        this.prepareCarousel(width);
    },
    computed: {
        centeredItemIndex() {
            return this.shift + Math.floor(this.showCount / 2);
        }
    },
    data() {
        return {
            isReady: false,
            showCount: null,
            itemsL: null,
            copiedItemsAfter: null,
            copiedItemsBefore: null,
            count: null,
            widthCarousel__wrapper: null,
            styleCarousel__wrapper: null,
            widthItem: null,
            styleItem: null,
            widthCarousel__inner: null,
            shift: null,
            shiftPx: null,
            runningAnimation: false,
            moveByN: 0
        };
    },
    methods: {
        handleResize() {
            if (this.runningAnimation === false) {
                const width = this.$refs.carousel.clientWidth - 2 * this.spaceSides;
                this.prepareCarousel(width);
            }
        },
        prepareCarousel(width) {
            this.isReady = false;
            const widthCarousel__wrapper = width;

            const spaceItemCount =  Math.floor(widthCarousel__wrapper / this.minItemWidth);
            let showCount = this.maxShowCount;
            if (spaceItemCount < this.maxShowCount) {
                if (spaceItemCount < 1) {
                    showCount = 1;
                } else {
                    showCount = spaceItemCount;
                }
            }

            if (showCount % 2 === 0) {
                showCount = showCount - 1;
            }

            const copiedItemsBefore = this.items.slice(-showCount);
            const copiedItemsAfter = this.items.slice(0, showCount);

            const count = this.items.length;
            const widthItem = widthCarousel__wrapper / showCount;
            const widthCarousel__inner = widthItem * count + (widthItem * (showCount * 2));

            const styleCarousel__wrapper = {
                width: `${widthCarousel__wrapper}px`,
                marginLeft: `${this.spaceSides}px`
            };

            const styleItem = {
                width: `${widthItem}px`
            };

            this.moveByN = (!this.defaultMoveByN || this.defaultMoveByN > showCount) ?
                showCount : this.defaultMoveByN;

            this.isReady = true;
            this.showCount = showCount;
            this.items = this.items;
            this.copiedItemsAfter = copiedItemsAfter;
            this.copiedItemsBefore = copiedItemsBefore;
            this.count = count;
            this.widthCarousel__wrapper = widthCarousel__wrapper;
            this.styleCarousel__wrapper = styleCarousel__wrapper;
            this.widthItem = widthItem;
            this.styleItem = styleItem;
            this.widthCarousel__inner = widthCarousel__inner;
            this.shift = showCount;
            this.shiftPx =  showCount * widthItem;
            this.runningAnimation = false;
        },
        move(targetShift) {
            this.runningAnimation = true;
            let counter = 0;
            const sumMove = this.widthItem * (targetShift - this.shift);
            this.shift = targetShift;

            const moveByPx = sumMove / this.animationFramesCount;

            counter++;
            this.shiftPx = this.shiftPx + moveByPx;

            if (counter >= this.animationFramesCount) {

                if (this.shift > this.items.length) {
                    this.shift = this.shift - this.items.length;
                    this.shiftPx = this.shift * this.widthItem;
                }

                if (this.shift < this.showCount) {
                    this.shift = this.shift + this.items.length;
                    this.shiftPx = this.shift * this.widthItem;
                }

                this.runningAnimation = false;
            }

            /*
            var interval = setInterval(() => {
                counter++;
                this.shiftPx = this.shiftPx + moveByPx;

                if (counter >= this.animationFramesCount) {

                    if (this.shift > this.items.length) {
                        this.shift = this.shift - this.items.length;
                        this.shiftPx = this.shift * this.widthItem;
                    }

                    if (this.shift < this.showCount) {
                        this.shift = this.shift + this.items.length;
                        this.shiftPx = this.shift * this.widthItem;
                    }

                    this.runningAnimation = false;
                    window.clearInterval(interval);
                }
            }, 100);//this.animationDuration / this.animationFramesCount);
            */


        }
    }
}
</script>


<style lang="scss" >

$baseHeight: 300px;
$shift: 30px;

.mm-carousel {
    .carousel__wrapper {
        margin-bottom: 1rem;
    }

    .carousel__inner {
        padding-top: 100px;
        height: 400px;
        overflow: hidden;
        transition-property: transform;
        transition-duration: 0.3s;
    }

    .item {
        float: left;
        font-size: 1.2rem;
        padding: 0px;
        position: relative;

    }

    .item-inner {
        padding: 1rem;
        margin: 0 1rem;
        background-color: white;
        height: $baseHeight;
        position: relative;
        border-radius: .6rem;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        box-shadow: 12px 0 15px -10px rgba(32, 44, 54, 0.28), -12px 0 8px -10px rgba(32, 44, 54, 0.28);
        margin: 0;
        opacity: 0;

        //transition: all .2s ease;
        //transition: opacity .2s ease;


        /*
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
        */
    }

    .item-inner {
        z-index: 2070;
    }

    .item-centered-sides-3 {
        z-index: 2080;
        //opacity: 1;
    }

    .item-centered-sides-2 {
        z-index: 2090;
        opacity: 1;
    }

    .item-centered-sides {
        height: $baseHeight + $shift;
        transform: translate(0px, -$shift - 8px) scale(1.05);
        z-index: 2100;
        opacity: 1;
    }

    .item-centered {
        height: $baseHeight + 2 * $shift;
        transform: translate(0px, -$shift * 2 - 16px) scale(1.1);
        z-index: 2110;
        opacity: 1;
    }

    .item-label {
        position: absolute;
        bottom: 10px;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 2.1rem;
        margin-bottom: 1.6rem;
        font-family: "Roboto", sans-serif;
        margin: 0.5rem 1.5rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        left: 0;
        right: 0;
        padding: 0.5rem;
    }

    .mask-carousel {
        background-position: right;
        position: absolute;
        border-radius: .6rem;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        height: 100px;
        bottom: 0;
        right: 0;
        left: 0;
        background-repeat: no-repeat;
        background: linear-gradient(to bottom , transparent 20%, rgba(255,255,255, 0.9) 50%);
        background-position: right;
    }

    .item-inner:hover {
        //border: 1px solid #00aeba;
        z-index: 99999;
        box-shadow: 0 0 4px 0px rgba(32, 44, 54, 0.98);
    }


    .button-move-left {
        position: absolute;
        left: -50px;
        top: 40%;
    }

    .button-move-right {
        position: absolute;
        right: -50px;
        top: 40%;
    }


    .carousel-button-wrapper {
        width: 60px;
    }

    .carousel-button-wrapper-move-left {
        position: absolute;
        left: -50px;
        top: 0;
        opacity: 0;
    }
    .carousel-button-wrapper-move-right {
        position: absolute;
        right: -50px;
        top: 0;
        opacity: 0;
    }

    @media (max-width: 991px) {
        .button-move-left {
            left: 0;
        }

        .button-move-right {
            right: 0;
        }
        .carousel-button-wrapper-move-left {
            left: -70px;
        }
        .carousel-button-wrapper-move-right {
            right: -70px;
        }
    }

    .carousel-button {
        width: 60px;
        height: 60px;
        cursor: pointer;
        font-size: 4rem;
        border-radius: 50px;
        background-color: rgba(255, 255, 255, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .carousel-button-wrapper {
        height: 100%;
    }

    .carousel-button:hover {
        color: #00AEBA;
    }
    /*
    @media (max-width: 480px) {
        .carousel__inner {
            -webkit-transition: none;
            -moz-transition: none;
            -o-transition: none;
            transition: none;
        }

        .item-inner {
            transition: none;
        }
    }
    */
}

</style>